var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "hide-header-menu inquiry-form" }, [
    _c(
      "div",
      {
        staticClass: "container",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row inquiry-form-header" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "inquiry-form-header__title text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.header.title")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-header__subtitle text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.header.subtitle")) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-form" }, [
          _c("div", { staticClass: "col-12 mx-auto" }, [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("schoolName") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "school-name-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.school_name")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.schoolName,
                      expression: "schoolName"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: {
                    "form-control-danger": _vm.errors.has("schoolName")
                  },
                  attrs: {
                    type: "text",
                    id: "school-name-input",
                    placeholder: _vm.$t(
                      "inquiry_form.form.school_name_placeholder"
                    ),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.schoolName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.schoolName = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("name") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "name-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.name")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("name") },
                  attrs: {
                    type: "text",
                    id: "name-input",
                    placeholder: _vm.$t("inquiry_form.form.name_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("position") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "position-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.position")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.position,
                      expression: "position"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("position") },
                  attrs: {
                    type: "text",
                    id: "position-input",
                    placeholder: _vm.$t(
                      "inquiry_form.form.position_placeholder"
                    ),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.position },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.position = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("email") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "email-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.email")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("email") },
                  attrs: {
                    type: "email",
                    id: "email-input",
                    placeholder: _vm.$t("inquiry_form.form.email_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-danger": _vm.errors.has("mobile") }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "inquiry-form-form__label",
                    attrs: { for: "mobile-input" }
                  },
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("inquiry_form.form.mobile")))
                    ]),
                    _c("span", { staticClass: "typography--color-accent" }, [
                      _vm._v("*")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mobile,
                      expression: "mobile"
                    }
                  ],
                  staticClass: "form-control basic-text-input",
                  class: { "form-control-danger": _vm.errors.has("mobile") },
                  attrs: {
                    type: "tel",
                    id: "mobile-input",
                    placeholder: _vm.$t("inquiry_form.form.mobile_placeholder"),
                    maxlength: "50",
                    required: ""
                  },
                  domProps: { value: _vm.mobile },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mobile = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  staticClass: "inquiry-form-form__label",
                  attrs: { for: "content-input" }
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("inquiry_form.form.content")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content"
                  }
                ],
                staticClass: "form-control basic-text-input",
                attrs: {
                  id: "content-input",
                  placeholder: _vm.$t("inquiry_form.form.content_placeholder"),
                  rows: "6"
                },
                domProps: { value: _vm.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-primary btn-full inquiry-form-form__submit-btn",
                  attrs: { disabled: _vm.isFormInvalid },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [
                  !_vm.busy
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.$t("inquiry_form.form.submit_btn")))
                      ])
                    : _c("LoadingBounce")
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-contact" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "inquiry-form-contact__title text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.contact.title")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-contact__subtitle text-center" },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-outline-primary inquiry-form-contact__subtitle-btn",
                    attrs: {
                      href: "tel:" + _vm.$t("inquiry_form.contact.subtitle")
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("inquiry_form.contact.subtitle")) +
                        "\n          "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inquiry-form-contact__desc text-center" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("inquiry_form.contact.desc")) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row inquiry-form-footer" }, [
          _c(
            "div",
            { staticClass: "col-12 text-center" },
            [_c("FooterContent")],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "inquiry-submitted-alert",
              "hide-header": true,
              "no-close-on-backdrop": true,
              "ok-title": _vm.$t("common.confirm")
            },
            on: { ok: _vm.goBack }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("inquiry_form.modal.inquiry_submitted_alert")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "basic-error-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.basic_error_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94fd00aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94fd00aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InquiryForm.vue
// module id = Ji8T
// module chunks = 1